import React, { useEffect, useMemo, useState, useCallback } from "react";
import MaterialReactTable from "material-react-table";
import { Info } from "@mui/icons-material";
import toast, { Toaster } from "react-hot-toast";

import axios from "axios";
import { fetchPartsApi } from "./Catalogue/Api/partsApi";
import { useNavigate } from "react-router-dom";

const SpecialOfferTable = ({ isVendorName }) => {
  const navigate = useNavigate();
  //data and fetching state
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [isOpenPopup, setIsOpenPopup] = useState(false);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const userId = localStorage.getItem("userId");
  const [user, dcode] = userId.split("-");

  const fetchPackageOffers = async () => {
    setIsLoading(true);
    const url = new URL(
      "/get-package-offers",
      `${process.env.REACT_APP_API_URL}`
    );
    if (isVendorName) {
      url.searchParams.set("user_id", userId);
    }
    url.searchParams.set("page", `${pagination.pageIndex}`);
    url.searchParams.set("size", `${pagination.pageSize}`);
    url.searchParams.set("filters", JSON.stringify(columnFilters ?? [])); //[{"id":"PARTNAME","value":"sa"}]
    url.searchParams.set("globalFilter", globalFilter ?? "");
    url.searchParams.set("sorting", JSON.stringify(sorting ?? []));
    try {
      const response = await axios.get(url);
      setData(response?.data?.data);
      setRowCount(response?.data?.total);
      console.log(response?.data, "sddfdfd");
    } catch (error) {
      console.log(error, "error fetching return product");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPackageOffers();
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    globalFilter,
    columnFilters,
    isVendorName,
  ]);

  const handleFetchPart = async (row) => {
    try {
      const filters = [{ id: "PARTNAME", value: row?.DEXT_OFFERPARTNAME }];
      const query = `?filters=${JSON.stringify(filters)}`;
      const { data } = await fetchPartsApi(query);
  
      const packageOfferDiscount =
        data?.length > 0
          ? data[0]?.discounts?.find(
              (discount) =>
                discount.DEXT_OFFERCODE === "4" && discount.PACKAGEOFFER === "Y"
            )
          : undefined;
  
      const stringifyProduct =
        data?.length > 0 ? JSON.stringify(data[0]) : undefined;
  
      if (stringifyProduct && packageOfferDiscount) {
        navigate(
          `/app/catalogue?currentBody=2&qpartname=${row?.DEXT_OFFERPARTNAME}`
        );
      } else {
        toast.error("Product is not available");
      }
    } catch (error) {
      console.error("Error fetching part:", error);
      toast.error("An error occurred while fetching the product.");
    }
  };

  const options = {
    filtering: true,
  };

  return (
    <>
      <MaterialReactTable
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: {
              align: "center",
            },
            size: 50,
          },
        }}
        columns={[
          {
            header: "Offer",
            accessorKey: "OFFERDES",
            enableColumnFilter: true,
            size: 11,
          },
          {
            header: "Action",
            accessorKey: "OFFERDES",
            enableColumnFilter: false,
            enableSorting: false,
            enableColumnActions: false,
            size: 1,
            Cell: ({ cell }) => {
              return (
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <Info
                    className="table-info-button"
                    style={{
                      color: "#1f79d5",
                      cursor: "pointer",
                      fontSize: "35px",
                    }}
                    onClick={() => {
                      // handleFetchPart(cell.row?.original);
                      navigate(
                        `/app/catalogue?currentBody=2&qpartname=${cell.row?.original?.DEXT_OFFERPARTNAME}&discountOfferId=${cell.row?.original?.OFFERNUM}`
                      );
                    }}
                  ></Info>
                </div>
              );
            },
          },
        ]}
        data={data}
        initialState={{
          showColumnFilters: true,
          density: window.innerWidth > 1024 ? "comfortable" : "standard",
        }}
        manualFiltering
        options={options}
        manualPagination
        manualSorting
        muiToolbarAlertBannerProps={
          isError
            ? {
                color: "error",
                children: "Error loading data",
              }
            : undefined
        }
        onGlobalFilterChange={setGlobalFilter}
        onColumnFiltersChange={setColumnFilters}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        rowCount={rowCount}
        state={{
          showGlobalFilter: false,
          columnFilters,
          globalFilter: false,
          isLoading,
          pagination,
          showAlertBanner: isError,
          showProgressBars: isRefetching,
          sorting,
        }}
      />
      <Toaster containerStyle={{ zIndex: 999999999999999 }} />
    </>
  );
};

export default SpecialOfferTable;
